import { FC } from 'react';
import { useAppSelector } from 'redux/hooks';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { OccupationArea } from 'components/SearchSideBar/BasicInfo/OccupationArea';
import { LocationArea } from 'components/SearchSideBar/BasicInfo/LocationArea';
import { IndustryArea } from 'components/SearchSideBar/BasicInfo/IndustryArea';
import { Props } from '../../..';

export const PreBtn1: FC<Props> = ({
  conditions,
  modalAction,
  getJobCountAtModalDisplay,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const { occupation, location, routeStation, industry } = conditions;
  const {
    onOpenOccupationModal,
    onOpenLocationModal,
    onOpenRouteModal,
    onOpenIndustryModal,
  } = modalAction;
  const {
    getJobCountWithoutOccupation,
    getJobCountWithoutLocationAndStation,
    getJobCountWithoutIndustry,
  } = getJobCountAtModalDisplay;

  const { ar, pr, ci, wa, rt, st } = useAppSelector(appQueryParamsSelector);

  return (
    <>
      {(ar || pr || ci || wa || rt || st) && (
        <LocationArea
          location={location}
          routeStation={routeStation}
          updateJobCount={updateJobCount}
          onClickOpenLocationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenLocationModal();
          }}
          onClickOpenStationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenRouteModal();
          }}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
        />
      )}
      <OccupationArea
        occupation={occupation}
        updateJobCount={updateJobCount}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
        onClickOpenModal={() => {
          getJobCountWithoutOccupation();
          onOpenOccupationModal();
        }}
      />
      {!(ar || pr || ci || wa || st || rt) && (
        <LocationArea
          location={location}
          routeStation={routeStation}
          updateJobCount={updateJobCount}
          onClickOpenLocationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenLocationModal();
          }}
          onClickOpenStationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenRouteModal();
          }}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
        />
      )}
      <IndustryArea
        industry={industry}
        updateJobCount={updateJobCount}
        onClickOpenModal={() => {
          getJobCountWithoutIndustry();
          onOpenIndustryModal();
        }}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
    </>
  );
};
